/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from "../icetypes";
import { contact } from '../common/contact';
import { address } from '../common/address';
import { entity } from '../common/entity';

export class taxauthority extends IceEntity {
  tax_authority_key: string = "";
  entity_key: string = "";
  address_key: string = "";
  tax_rate: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  CONS: contact[] = [];
  ADS: address[] = [];
  ENTS: entity[] = [];

  constructor() {
    super();
  }

  gettablename(): string {
    return "TAX_AUTHORITY";
  }

  hassubtree(ColumnName: string): boolean {
    if (ColumnName.length == 0) return false;
    else if (ColumnName == "CONS") return true;
    else if (ColumnName == "ADS") return true;
    else if (ColumnName == "ENTS") return true;

    return false;
  }

  getsubtreetablename(ColumnName: string): string {
    if (ColumnName.length == 0) return null;
    else if (ColumnName == "CONS") return "CONTACT";
    else if (ColumnName == "ADS") return "ADDRESS";
    else if (ColumnName == "ENTS") return "ENTITY";

    return null;
  }

}
